import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartPie, faCoins, faDoorOpen, faHouse, faLayerGroup, faWallet, } from "@fortawesome/free-solid-svg-icons";

export default function Sidebar({ activeTab, handleTabClick, isSidebarOpen, setIsSidebarOpen }) {
    const TabButton = ({ icon, label, tab }) => (
        <button
            className={`flex items-center w-full px-5 py-2  ${tab === activeTab ? "bg-[#4169E114] text-[#856E4F]" : ""
                } ${isSidebarOpen ? "justify-start rounded-md" : "justify-center rounded-xl"}`}
            onClick={() => handleTabClick(tab)}
        >
            <span className={`flex items-center gap-3`}>
                {icon}
                {isSidebarOpen && <span className="text-sm">{label}</span>}
            </span>
        </button>
    );

    return (
        <>
            <div
                className={`transition-all hidden md:block ease-in-out duration-500 ${isSidebarOpen ? "w-[20%] lg:w-[15%]" : "w-[7%] lg:w-[5%]"} bg-black h-screen text-white`}>
                <div className="w-full" onMouseEnter={() => setIsSidebarOpen(true)} onMouseLeave={() => setIsSidebarOpen(false)}>
                    <nav className="mt-5"  >
                        <div className="flex flex-col gap-5 text-[#A7A8AB] ">
                            <TabButton
                                icon={<FontAwesomeIcon icon={faHouse} size="lg" />}
                                tab="Dashboard"
                                label="Dashboard"
                            />
                            <TabButton
                                icon={<FontAwesomeIcon icon={faLayerGroup} size="lg" />}
                                tab="Send"
                                label="Send"
                            />
                            <TabButton
                                icon={<FontAwesomeIcon icon={faWallet} size="lg" />}
                                tab="Deposit"
                                label="Deposit"
                            />
                            <TabButton
                                icon={<FontAwesomeIcon icon={faChartPie} size="lg" />}
                                tab="Transaction"
                                label="Transaction"
                            />
                            <TabButton
                                icon={<FontAwesomeIcon icon={faCoins} size="lg" />}
                                tab="Withdraw"
                                label="Withdraw"
                            />{/*
                            <TabButton
                                icon={<FontAwesomeIcon icon={faNetworkWired} size="lg" />}
                                tab="SelectNetwork"
                                label="SelectNetwork"
                            />*/}
                            <TabButton
                                icon={<FontAwesomeIcon icon={faDoorOpen} size="lg" />}
                                tab="Logout"
                                label="Logout"
                            />
                        </div>
                    </nav>
                </div>
            </div>

        </>
    );
}
